export const NOVALUE = "—"; // this is an em dash, NOT a hyphen
export const ERROR_REQUIRED_TXT = "Required";
export const COMMON_ERROR_TEXT = "Required";
export const ERROR_NO_FUTURE_DATES = "Date is in future";
